import api from './api';

// GET active service locations
export const getActiveLocations = async () => {
  const { data } = await api.get('/vehicle/service-locations/active');
  return data;
};

// GET rental / outstation packages
// mode: 'rental' | 'outstation'
export const getPackages = async (mode = 'rental') => {
  const { data } = await api.get(
    `/vehicle/rental/cab-vehicle-packages?mode=${mode}`
  );
  return data;
};

// POST available vehicles (one_way / round_trip)
export const searchAvailableVehicles = async (payload) => {
  const { data } = await api.post('/vehicle/available-vehicles', payload);
  return data;
};